import { Alert } from '@/common/components/Alert/Alert';
import { Stack } from '@/common/components/Stack/Stack';

export const PlaygroundAlerts = () => {
  return (
    <Stack gap="md">
      <Alert type="success" onClose={() => {}}>
        Success alert.
      </Alert>
      <Alert type="warning">Warning alert.</Alert>
      <Alert type="error">Error alert.</Alert>
      <Alert type="info">Info alert.</Alert>
      <Alert type="success" noBackground>
        Tiny Success alert.
      </Alert>
      <Alert type="warning" noBackground>
        Tiny Warning alert.
      </Alert>
      <Alert type="error" noBackground>
        Tiny Error alert.
      </Alert>
      <Alert type="info" noBackground>
        Tiny Info alert.
      </Alert>
    </Stack>
  );
};
